export const actions = {
    POST_COMMENTS: 'POST_COMMENTS',
    POST_COMMENTS_SUCCESS: 'POST_COMMENTS_SUCCESS',
    POST_COMMENTS_FAILURE: 'POST_COMMENTS_FAILURE',
}

export const postComments = (payload, orderDetails) => ({
    type: actions.POST_COMMENTS,
    payload,
    orderDetails,
})

export const postCommentsSuccess = () => ({
    type: actions.POST_COMMENTS_SUCCESS,
})

export const postCommentsFailure = error => ({
    type: actions.POST_COMMENTS_FAILURE,
    payload: error,
})
